/**
 * Converts a value (string or string array) into an array of strings
 * @param value - The value to convert
 * @returns An array of strings
 */
export const valueToArray = (value: string | string[] | null | undefined): string[] => {
  if (!value) return []
  if (Array.isArray(value)) return value.filter(Boolean)
  return String(value)
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean)
}

/**
 * Converts an array of strings into a CSV string
 * @param array - The array of strings to convert
 * @returns A CSV string
 */
export const arrayToCsv = (array: string[]): string => {
  return array.join(',')
}

export default { valueToArray, arrayToCsv }
